import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import getCurrentWorkoutExerciseSelect from '../get-current'
import { createSelector } from 'reselect'

const getCurrentIdWorkoutExerciseSelect = createSelector(getCurrentWorkoutExerciseSelect,
  (value) => {
    return getIdReduxUtil(value)
  }
)

export default getCurrentIdWorkoutExerciseSelect
